import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../../../../api/axios";
import { sleep } from "../../../../../functions";
import TransactionsContext from "./context";
import useAlert from "../../../../../globalComponents/useAlerts";
import Transaction from "../../../../../classes/transaction";

const generateNewTransaction = function () {
  return {
    amount: 0,
    type: Transaction.TYPES.ADJUST.value,
    source: Transaction.SOURCES.MANUAL.value,
    multiplier: 1,
    expirable: false,
    expireDate: null,
    description: "",
    amount: 0,
  };
};

export const useTransactionsManager = (customer) => {
  const { showAlert, showLoading, dismissLoading } = useAlert();

  const navigate = useNavigate();
  const [request, setRequest] = useState({
    loading: true,
    data: [],
    page: 0,
    limit: 10,
  });

  const create = async (transaction, onCreated) => {
    try {
      showLoading();

      const data = await axios.post("/transactions", {
        ...transaction,
        customer: customer._id,
      });

      if (typeof onCreated === "function") onCreated();

      const nData = {
        ...data,
        id: data._id,
        createdAt: new Date(data.createdAt).toLocaleString(),
        updatedAt: new Date(data.updatedAt).toLocaleString(),
      };

      setRequest((p) => ({ ...p, data: [nData, ...p.data] }));

      dismissLoading();
    } catch (e) {
      showAlert({ title: "Atenção", description: e.message });
    }
  };

  const getCustomerTransactions = useCallback(async () => {
    const mData = { ...request };
    try {
      request.loading = true;
      //showLoading();
      const res = await axios.get(
        `/transactions?&page=${request.page + 1}&limit=${request.limit}&customer=${customer._id}`,
      );

      const { data, error, ...rest } = res;

      if (error) throw new Error(error);

      const formattedData = data.map(({ ...p }, index) => ({
        ...p,
        id: p._id,
        createdAt: new Date(p.createdAt).toLocaleString(),
      }));

      Object.assign(mData, { ...data, data: formattedData, ...rest });
    } catch (e) {
      console.log(e);
      mData.data = [];
    } finally {
      mData.loading = false;
      await sleep(1000);
      setRequest(mData);
    }
  }, [request.page, request.limit]);

  const onNextPage = ({ page, pageSize }) => {
    if (request.loading) return;
    setRequest((o) => ({ ...o, page, loading: true, limit: pageSize }));
  };

  useEffect(() => {
    async function fetchdata() {
      return getCustomerTransactions();
    }

    fetchdata();
    return () => {};
  }, [getCustomerTransactions]);

  return {
    request,
    create,
    getCustomerTransactions,
    generateNewTransaction,
    transactionTypes: (function () {
      const { ADJUST } = Transaction.TYPES;
      return [ADJUST];
    })(),

    transactionSources: (function () {
      const { MANUAL } = Transaction.SOURCES;

      return [MANUAL];
    })(),
    onNextPage,
  };
};

export const useTransactions = () => useContext(TransactionsContext);
